module.exports = __webpack_public_path__ + "img/home-icon.5c7cd66e.svg";